export default __webpack_public_path__ + "8f50a73d514a83b574f562bd966d783e.png";